export default __webpack_public_path__ + "static/media/picThaoNguyen.441e07a0.png";